module.exports = __webpack_public_path__ + "static/part-14-36cfc7deddda2c16aa6679f77c72c983.svg";